/** @param {string} trimmed */
export function normalizeGeneratedArtifactPrompt(trimmed) {
  return trimmed.replace(/\s+/g, ' ').trim()
}

export const CREATE_DOC_RE = /\bcreate\s+(?:a\s+)?(?:doc(?:ument)?)\b/i
export const CREATE_SPREADSHEET_RE =
  /\bcreate\s+(?:a\s+)?(?:(?:xl|excel)[\s-]*(?:sheet|shee?t|workbook)|spreadsheet|workbook)\b/i
export const CREATE_APP_RE = /\bcreate\s+(?:a\s+)?(?:(?:html\s+)?(?:app|site|page)|web\s+app)\b/i
export const NAME_AFTER_RE = /\b(?:called|named|titled|:)\s+(.+)$/i
